<h1>Request Subscriptions</h1>

@if (subscribed) {
    <section>
        <h2><code>{{dealer.pa_code}}</code> is enrolled in FDSP!</h2>
        <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>.</p>
        <ul>
            @if(fleet) {
                <li>FIN Code: {{dealer.pa_code}}</li>
            } @else {
                <li>PA Code: {{dealer.pa_code}}</li>
            }            
            <li>Current Subscriptions: {{tech_count.toLocaleString()}}</li>
        </ul>
        @if(fleet) {
            <p><label>New total subscriptions requested: <input [(ngModel)]="tech_count_requested" type="number" min="1" step="1"></label></p>
        } @else {
            <p><label>New total subscriptions requested: <input [(ngModel)]="tech_count_requested" type="number" min="0" step="1"></label></p>
        }
        @if(tech_count != tech_count_requested) {
            <p>(Requesting change from {{tech_count.toLocaleString()}} to {{tech_count_requested}} subscriptions.)</p>
        }        
        @if(!fleet) {
            <p><label>Notes</label><br><textarea [(ngModel)]="notes"></textarea></p>
        }
        <p><label><input type="checkbox" [(ngModel)]="isChecked"> I agree to the <a href="https://www2.helminc.com/ngsm/languages/en/Non_RS_Terms.pdf" target="tos">terms of sale</a>.</label></p>
        @if(fleet) {
            <p><button (click)="createRequest()" [disabled]="!isChecked || tech_count_requested == 0 || tech_count == tech_count_requested">Request Subscriptions</button></p>
        } @else if(!fleet) {
            <p><button (click)="createRequest()" [disabled]="!isChecked || tech_count == tech_count_requested">Request Subscriptions</button></p>
        }
    </section>
} @else {
    <section>
        <h2><code>{{dealer.pa_code}}</code> is not currently enrolled in FDSP.</h2>
        <p>{{dealer.name}} - {{dealer.pa_code}} is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.</p>
        @if(fleet) {
            <p><label>Number of subscriptions requested: <input [(ngModel)]="tech_count_requested" type="number" min="1" step="1"></label></p>
        } @else {
            <p><label>Number of subscriptions requested: <input [(ngModel)]="tech_count_requested" type="number" min="0" step="1"></label></p>
            <p><label>Notes</label><br><textarea [(ngModel)]="notes"></textarea></p>
        }
        <p><label><input type="checkbox" [(ngModel)]="isChecked"> I agree to the <a href="https://www2.helminc.com/ngsm/languages/en/Non_RS_Terms.pdf" target="tos">terms of sale</a>.</label></p>
        <p><button (click)="createRequest()" [disabled]="!isChecked || tech_count_requested < 1">Request Subscriptions</button></p>
    </section>
}